module.exports = __webpack_public_path__ + "media/images/pages/ai/pocstock-ethical-ai-face-32@2x-6aa40ca6ed1f019d11f51066ad0f11f4.png";